import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/messaging';
import 'firebase/functions';

import {
  firebaseConfig,
  isFirebaseConfigured,
  missingFirebaseConfig,
} from '../Config/env';

if (!isFirebaseConfigured) {
  throw new Error(
    `Configuration Firebase incomplète : ${missingFirebaseConfig.join(', ')}. ` +
      'Copiez .env.example vers .env.local et complétez les valeurs.',
  );
}

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export default firebase;
